import { render } from "./locations.vue?vue&type=template&id=5af8199c&scoped=true&ts=true"
import script from "./locations.vue?vue&type=script&lang=ts"
export * from "./locations.vue?vue&type=script&lang=ts"

import "./locations.vue?vue&type=style&index=0&id=5af8199c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af8199c"]])

export default __exports__